/**
 * format-money.ts — Định dạng tiền VND cho các màn tài liệu bán hàng.
 *
 * Bên ChatMQL hàm này nằm trong `lib/order-calc.ts` của module Đơn hàng; eCDP
 * không port module đó nên tách riêng đúng phần cần, không kéo theo cả bộ tính
 * đơn hàng.
 */
export function formatVnd(n: number | null | undefined): string {
  const v = Math.round(Math.max(0, Number(n) || 0))
  return `${new Intl.NumberFormat('vi-VN').format(v)} ₫`
}
